module.exports = __webpack_public_path__ + "img/magnum-club__bg.1feb3037.jpg";